// Colors — imported from colors.js (single source of truth)
// Use colors.bgPaper, colors.bgSubtle, colors.border in sx props.
// The Proxy in colors.js makes these values dynamic (reactive to dark mode).
export { colors } from './colors';

export const DECL_STATUS = {
  draft:               { label: 'Brouillon',                color: 'default' },
  ready:               { label: 'Prêt',                     color: 'success' },
  waiting_signatures:  { label: 'En attente de signatures', color: 'warning' },
  signature_confirmed: { label: 'Signatures confirmées',    color: 'info'    },
  sent_to_sacem:       { label: 'Envoyé à la SACEM',        color: 'primary' },
};

export const STATUS_ORDER = [
  'draft', 'ready', 'waiting_signatures', 'signature_confirmed', 'sent_to_sacem',
];

export const MONTHLY_LIMIT = parseInt(process.env.REACT_APP_MONTHLY_LIMIT || '30', 10);

// Fallback pricing (cents + monthly quotas) mirroring the backend defaults.
// Used by usePricing() when GET /config/pricing/ is unavailable, so the UI
// never flashes inconsistent values.
export const DEFAULT_PRICING = {
  unit_price_cents: 990,
  standard_price_cents: 3990,
  standard_declarations_per_month: 8,
  pro_price_cents: 9990,
  pro_declarations_per_month: 30,
};

// Mirrors DECLARATION_TITLE_MAX_LENGTH in the backend (folder name, not the
// SACEM work title).
export const DECLARATION_TITLE_MAX_LENGTH = 30;

// Mirrors ACCOUNT_DELETION_GRACE_DAYS in the backend (GDPR erasure grace period).
export const DELETION_GRACE_DAYS = 30;

/** Returns 's' when |n| !== 1, otherwise ''. Avoids repeated pluralization ternaries. */
export const s = n => Math.abs(n) !== 1 ? 's' : '';

export const FILE_TYPES = [
  { value: 'sacem_form',      label: 'Formulaire SACEM' },
  { value: 'session_edition', label: "Contrat de cession et d'édition musicale" },
  { value: 'coedition',       label: "Contrat d'une coédition d'une œuvre musicale" },
];
